import React, { useEffect, useState } from "react";
import {
  DateInput,
  NumberInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import Table from "../../components/common/table/Table";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import PDFExport from "../../components/common/ui/Export/PDFExport";
import ToggleSwitch from "../../components/common/ui/Inputs/ToggleSwitch";
import { history } from "../../_helpers";
import { useDispatch, useSelector } from "react-redux";
import { authActions, inmateAction, masterActions } from "../../_store";
import CustomLoader from "../../components/common/ui/Loader";
import activeIcon from "../../assets/svg/active-user.svg";
import inactiveIcon from "../../assets/svg/inactive-user.svg";
import generateXlsx from "../../components/common/export/generateXlsx";
import { fDate, MinDate, Today } from "../../utils/formatTime";
import Activeicon from "../../assets/svg/active-user.svg";
import Inactiveicon from "../../assets/svg/inactive-user.svg";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import Swal from "sweetalert2";
import useManagementUserAccessPermission from "../../hooks/useManagementUserAccessPermission";

function InmateList() {
  const { facilityDropDown: facilitydata, GetPodList: podList } = useSelector(
    (state) => state.master
  );
  const { commonFacilityCode: facilityCode } = useSelector(
    (state) => state.auth
  );

  const {
    loading,
    inmateList,
    inmateFullList,
    securityResponse,
    inmateSearchData: inmate,
  } = useSelector((state) => state.inmate);

  const [isLoading, setisLoading] = useState(false);

  const isPageReloading = useSelector((state) => state.master?.isPageReload);
  const [showSearchFields, setShowSearchFields] = useState(false);
  const { Status, genderDropdown, sharedPodOptions } = useSelector(
    (state) => state.dropdownOptions
  );
  const { InmateAccessPermission } = useManagementUserAccessPermission();
  const { user } = useSelector((x) => x.auth);

  const dispatch = useDispatch();

  // const [inmate, setInmate] = useState({
  //   InmateResidentID: "",
  //   UserFirstName: "",
  //   UserLastName: "",
  //   FacilityID: 0,
  //   PodID: 0,
  //   InmatesGender: 0,
  //   DobStartDate: "",
  //   DobEndDate: "",
  //   KiosksAccess: 2,
  //   ActiveStatus: 1,
  //   PageNo: 1,
  //   RowCountPerPage: 10,
  //   SortField: "",
  // });

  useEffect(() => {
    if (securityResponse?.IsSucceed === 1) {
      dispatch(inmateAction.LoadInmatesSearch(inmate));
      showToastNotification("Updated successfully.", "success");
      dispatch(inmateAction.clearSecurityResponse());
    }
  }, [securityResponse]);

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (facilityCode === 0) return;
    // setInmate((prev) => ({
    //   ...prev,
    //   FacilityID: facilityCode,
    // }));
    dispatch(
      inmateAction.setInmateSearchData({
        ...inmate,
        FacilityID: facilityCode,
      })
    );
    dispatch(masterActions.GetPODList(facilityCode));
    setisLoading(true);
    dispatch(
      inmateAction.LoadInmatesSearch({
        ...inmate,
        FacilityID: facilityCode,
      })
    ).then((x) => { setisLoading(false) })
  }, [facilityCode, isPageReloading]);


  const navigateToDetailsPage = (row) => {
    if (InmateAccessPermission[0]?.SubMenuActiveStatus == 0 || user?.UserRoleID == 13) return;
    Swal.close();
    dispatch(inmateAction.clearPhotogridList());
    if (InmateAccessPermission[0]?.SubMenuActiveStatus === 0) {
      return;
    }

    history.navigate("InmateList/Details", {
      state: { inmate: row, showTransactionTab: false },
    });

    dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
    // dispatch(inmateAction.setInmate("row"));


  };

  const columns = [
    {
      name: "Inmate ID",
      key: "InmateID",
      selector: (row) => row.InmateResidentId,
      cell: (row) => (
        <div
          onClick={() => navigateToDetailsPage(row)}
          className={` ${(InmateAccessPermission[0]?.SubMenuActiveStatus !== 0 && user?.UserRoleID !== 13)
            ? "Common_Link_Style"
            : ""
            }`}
        >
          {row.InmateResidentId}
        </div>
      ),

      sortable: true,
    },
    {
      name: "Last Name",
      key: "LastName",
      selector: (row) => row.LastName,
      sortable: true,
    },
    {
      name: "First Name",
      key: "FirstName",
      selector: (row) => row.FirstName,
      sortable: true,
    },
    {
      name: "POD",
      key: "PodCode",
      selector: (row) => {
        // Conditionally apply color based on PodStatus
        const textClass = row.PodStatus === 0 ? "label-red" : "text-dark";
        const title =
          row.PodStatus === 0
            ? "Pod needs to be created for selected facility"
            : "";
        return (
          <span className={textClass} title={title}>
            {row.PodCode}
          </span>
        );
      },
      sortable: true,
    },
    {
      name: "Gender",
      key: "Gender",
      selector: (row) => row.Gender,
      sortable: true,
    },
    { name: "DOB", key: "DOB", selector: (row) => row.DOB, sortable: true },
    {
      name: "Connection Count",
      key: "PubliInmateConnectionCount",
      selector: (row) => row.PubliInmateConnectionCount,
      sortable: true,
    },
    {
      name: "Free Credits($)",
      key: "InmateFreeCreditAmount",
      selector: (row) => row.InmateFreeCreditAmount?.toFixed(2),
      sortable: true,
    },
    {
      name: "Status",
      key: "status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <div className="d-flex flex-wrap justify-content-center align-items-center h-100">
          <img
            title={row.InmateStatus}
            src={row?.InmateStatus === "Current" ? activeIcon : inactiveIcon}
            alt={
              row.InmateStatus === "Current" ? "Active User" : "Inactive User"
            }
            style={{ width: "20px", height: "20px" }} // Adjust icon size as needed inactiveIcon
          />
        </div>
      ),
    },

    {
      name: "Security",
      key: "IsFacilitySQ",
      selector: (row) => row.security,
      sortable: true,
      hide: inmateList?.DataList?.[0]?.IsFacilitySQ === 0 ? true : false,
      cell: (row, index) => (
        <label className="form-switch">
          <input
            type="checkbox"
            onChange={(e) => handleToggleSwitchChange(e, row)}
            className={"form-check-input"}
            value={row.IsSQ === 1}
            id={`Status${row.InmateID}`}
            name={`Status${row.InmateID}`}
            checked={row.IsSQ === 1}
          />
          <span className={"form-slider round"}></span>
        </label>
      ),
    },
  ];

  const visibleColumns = columns.filter((column) => !column.hide);

  const handleToggleSwitchChange = (e, row) => {
    let checked = e.target.checked === true ? 1 : 0;

    dispatch(
      inmateAction.InmateSecurityQuestion({
        inmateId: row.InmateID,
        facilityID: row.facilityID,
        action: checked,
      })
    );
  };

  const handleSubmit = (e) => {
    e?.preventDefault();

    dispatch(
      inmateAction.setInmateSearchData({
        ...inmate,
        PageNo: 1,
        RowCountPerPage: 10,
      })
    );
    setisLoading(true);
    dispatch(
      inmateAction.LoadInmatesSearch({
        ...inmate,
        PageNo: 1,
        RowCountPerPage: 10,
      })
    ).then((x) => { setisLoading(false) })
  };

  const handleRowPerPage = (value) => {
    // setInmate((prev) => ({
    //   ...prev,
    //   RowCountPerPage: value,
    // }));
    dispatch(
      inmateAction.setInmateSearchData({
        ...inmate,
        PageNo: 1,
        RowCountPerPage: value,
      })
    );
    dispatch(inmateAction.LoadInmatesSearch({ ...inmate, FacilityID: facilityCode, PageNo: 1, RowCountPerPage: value }));
  };

  const handlePageChange = (value) => {
    if (sorting) {
      sorting = false;
      return;
    }
    // Update PageNo in the state only when page is changed
    // if (value !== inmate?.PageNo) {
    dispatch(
      inmateAction.setInmateSearchData({
        ...inmate,
        PageNo: value, // Update the page number
      })
    );
    dispatch(inmateAction.LoadInmatesSearch({ ...inmate, FacilityID: facilityCode, PageNo: value, }));
    // }
  };

  //Export Excel

  useEffect(() => {
    if (inmateFullList && inmateFullList?.DataList?.length > 0) {
      let title = "Inmates_List";
      let generateExcelColumns = [
        "Inmate ID",
        "Last Name",
        "First Name",
        "POD",
        "Gender",
        "DOB",
        "Connection Count",
        "Free Credits($)",
        "Status",
      ];

      // Map the account manager list to match the Excel format
      let Inmates_List =
        inmateFullList?.DataList?.map((obj) => ({
          InmateID: obj.InmateResidentId,
          LastName: obj.LastName,
          FirstName: obj.FirstName,
          PodCode: obj.PodCode,
          Gender: obj.Gender,
          DOB: obj.DOB,
          PubliInmateConnectionCount: String(obj.PubliInmateConnectionCount),
          InmateFreeCreditAmount: String(obj.InmateFreeCreditAmount.toFixed(2)),
          InmateStatus: obj.InmateStatus,
        })) || [];

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(Inmates_List, generateExcelColumns, title);

        // Clear excel data after the download
        dispatch(inmateAction.clearInmateFullList());
      } catch (error) {
        // Handle any errors that occur during Excel generation
        console.error("Error generating Excel file:", error);
      }
    }
  }, [inmateFullList]);

  const handleClickExcel = () => {
    // Define the title and column headers for the Excel file

    const updateTotalRows = {
      ...inmate,
      PageNo: 1,
      RowCountPerPage: inmateList?.TotalRecordCount,
      exportExcel: true, // Flag to indicate Excel export
    };

    dispatch(inmateAction.LoadInmatesSearch(updateTotalRows));
  };

  //OnChange

  const handleChange = (e) => {
    e.preventDefault();

    let { value, name } = e?.target;

    // setInmate((prev) => ({
    //   ...prev,
    //   [name]:
    //     name === "UserLastName" || name === "UserFirstName"
    //       ? value.trimStart()
    //       : value,
    // }));

    dispatch(
      inmateAction.setInmateSearchData({
        ...inmate,
        [name]:
          name === "UserLastName" || name === "UserFirstName"
            ? value.trimStart()
            : name === "InmateResidentID"
              ? value.replace(/[^0-9]/g, "")
              : value,
      })
    );
  };

  let updatedInmates = { ...inmate, PageNo: 1, RowCountPerPage: 10 };

  const handleSelectChange = (selectedOptions, name) => {
    if (name === "PodID") {
      updatedInmates[name] = selectedOptions?.value || 0;
    } else if (name === "ActiveStatus") {
      updatedInmates[name] = updatedInmates[name] =
        selectedOptions?.value == null ? 1 : selectedOptions.value;
    } else if (name === "InmatesGender") {
      updatedInmates[name] = selectedOptions?.value || 0;
    } else if (name === "KiosksAccess") {
      updatedInmates[name] =
        selectedOptions?.value == null ? 2 : selectedOptions?.value;
    }

    dispatch(inmateAction.setInmateSearchData(updatedInmates));

    // setInmate(updatedInmates);

    dispatch(inmateAction.LoadInmatesSearch(updatedInmates));
  };

  const handleDateChange = (name, value) => {
    const date = fDate(value);

    // setInmate((prev) => ({
    //   ...prev,
    //   [name]: date,
    // }));

    dispatch(
      inmateAction.setInmateSearchData({
        ...inmate,
        [name]: date,
      })
    );
  };

  //
  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && inmate[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDateChange(name, currentDate);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "DobStartDate") {
      if (inmate.DobEndDate && new Date(value) > new Date(inmate.DobEndDate)) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "DobEndDate") {
      if (
        inmate.DobStartDate &&
        new Date(value) < new Date(inmate.DobStartDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...inmate,
      DobStartDate:
        fieldName === "DobStartDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : inmate.DobStartDate, // preserve existing value
      DobEndDate:
        fieldName === "DobEndDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : inmate.DobEndDate, // preserve existing value
    };

    dispatch(inmateAction.setInmateSearchData(updatedParam));
  };

  //Reset
  const initialState = {
    InmateResidentID: "",
    UserFirstName: "",
    UserLastName: "",
    FacilityID: facilityCode,
    PodID: 0,
    InmatesGender: 0,
    DobStartDate: "",
    DobEndDate: "",
    KiosksAccess: 2,
    ActiveStatus: 1,
    PageNo: 1,
    RowCountPerPage: 10,
    SortField: "",
  };

  const handleSearchReset = () => {
    dispatch(inmateAction.setInmateSearchData(initialState));
    // setInmate(initialState);
    dispatch(inmateAction.LoadInmatesSearch(initialState));
  };

  // const [sorting, setSorting] = useState(false);
  let sorting = false; // to restrict the pagination issue
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    // setSorting(true);
    sorting = true;
    const search = { ...inmate };
    const newSortOrder = search.SortField.includes(column.key)
      ? search.SortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortField = `${column.key} ${newSortOrder}`;
    dispatch(inmateAction.setInmateSearchData(search));
    dispatch(
      inmateAction.LoadInmatesSearch({
        ...inmate,
        SortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  if (loading || isLoading) {
    return <CustomLoader />;
  }

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };
  const renderSearch = () => {
    return (
      <form onSubmit={(e) => handleSubmit(e)}>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <NumberInput
                name="InmateResidentID"
                label="Inmate ID"
                value={inmate?.InmateResidentID}
                handleChange={handleChange}
                type="text"
                placeholder="Enter Inmate ID"
                required={false}
                maxLength={18}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="PodID"
                options={podList}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={inmate?.PodID !== 0}
                label="POD"
                placeholder="Select POD"
                value={inmate?.PodID}
                handleChange={(e) => handleSelectChange(e, "PodID")}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="ActiveStatus"
                options={Status}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={inmate?.ActiveStatus !== 1}
                label="Status"
                placeholder="Select Status"
                value={inmate?.ActiveStatus}
                handleChange={(e) => handleSelectChange(e, "ActiveStatus")}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="UserLastName"
                id="UserLastName"
                label="Last Name"
                value={inmate?.UserLastName}
                handleChange={handleChange}
                placeholder="Enter Last Name"
                required={false}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="UserFirstName"
                id="UserFirstName"
                label="First Name"
                value={inmate?.UserFirstName}
                handleChange={handleChange}
                placeholder="Enter First Name"
                required={false}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="InmatesGender"
                options={genderDropdown}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={inmate?.InmatesGender !== 0}
                label="Gender"
                placeholder="Select Gender"
                value={inmate?.InmatesGender}
                handleChange={(e) => handleSelectChange(e, "InmatesGender")}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                label="DOB Start Date"
                name="DobStartDate"
                value={inmate?.DobStartDate}
                maxDate={inmate?.DobEndDate ? inmate?.DobEndDate : new Date()}
                handleChange={(e) => handleDateChange("DobStartDate", e)}
                yearDropDown={true}
                isClearable={inmate?.DobStartDate}
                preventClear={false}
                minDate={new Date(1900, 0, 1)}
                handleBlur={(e) => handleDateBlur(e, "DobStartDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "DobStartDate")}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                label="DOB End Date"
                name="fromDate"
                value={inmate?.DobEndDate}
                minDate={
                  inmate.DobStartDate
                    ? inmate.DobStartDate
                    : new Date(1900, 0, 1)
                }
                maxDate={new Date()}
                handleChange={(e) => handleDateChange("DobEndDate", e)}
                isClearable={inmate?.DobEndDate}
                preventClear={false}
                handleBlur={(e) => handleDateBlur(e, "DobEndDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "DobEndDate")}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="KiosksAccess"
                label="Kiosks Access"
                options={sharedPodOptions}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={inmate?.KiosksAccess !== 2}
                placeholder="Select KiosksAccess"
                value={inmate?.KiosksAccess}
                handleChange={(e) => handleSelectChange(e, "KiosksAccess")}
              />
            </div>
          </div>
        </div>

        <div className="d-flex flex-wrap justify-content-center gap-3 flex-wrap mt-3">
          <Button
            variant="primary"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          />

          <Button
            variant="secondary"
            className="me-2"
            onClick={handleSearchReset}
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };
  return (
    <div>
      {facilityCode ? (
        <div className="inmate">
          <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
            <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
              <div className=" d-block d-md-none">
                <div
                  className=" d-flex align-items-center justify-content-between"
                  style={{ background: "transparent", cursor: "pointer" }}
                  onClick={toggleInformation}
                >
                  <h2 className="form_title_uppercase text-color">
                    Inmate SEARCH
                  </h2>
                  <i
                    id="itagInformation"
                    className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                      }`}
                    style={{ fontSize: "20px" }}
                  ></i>
                </div>
              </div>
              {/* Mobile only (Below md breakpoint) */}
              <div className="d-block d-md-none mt-2">
                {showSearchFields && renderSearch()}
              </div>

              {/* Web only (Desktop and above) */}
              <div className="mb-3 d-none d-md-block">
                <h2 className="form_title_uppercase text-color">
                  Inmate SEARCH
                </h2>
              </div>
              {/* Web only (Desktop and above) */}
              <div className="d-none d-md-block">{renderSearch()}</div>
            </div>
            <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
              {/* <div className="d-flex flex-wrap justify-content-between align-items-center"> */}
              {/* <h2 className="mb-4 text-color"></h2> */}

              <div className="d-flex flex-wrap justify-content-center align-items-center mb-2 resp-space">
                <h2 className="text-color">INMATES LIST</h2>

                <div className="ms-auto">
                  {inmateList?.DataList?.length > 0 && (
                    <ExcelExport
                      className="ms-auto"
                      handleExcelExport={handleClickExcel}
                    />
                  )}
                </div>
              </div>
              {inmateList?.DataList?.length > 0 && (
                <div className="d-flex flex-wrap gap-4 mb-2">
                  <div className="mt-2">
                    <img
                      title={Activeicon}
                      src={Activeicon}
                      alt={Activeicon}
                      className="in-icon-size"
                    />
                    <span className="ms-2 fw-600 font-size-15 v-mid">
                      Inmate Current
                    </span>
                  </div>
                  <div className="mt-2">
                    <img
                      title={Inactiveicon}
                      src={Inactiveicon}
                      alt={Inactiveicon}
                      className="in-icon-size"
                    />
                    <span className="ms-2 fw-600 font-size-15 v-mid">
                      Inmate Released
                    </span>
                  </div>
                </div>
              )}

              {/* </div> */}
              <Table
                columns={visibleColumns}
                data={inmateList?.DataList}
                pagination
                onChangeRowsPerPage={handleRowPerPage}
                onChangePage={handlePageChange}
                totalRowCount={inmateList?.TotalRecordCount}
                currentPage={inmate?.PageNo}
                paginationPerPage={inmate?.RowCountPerPage}
                serverSideSort
                onSort={handleSort}
                sortColumn={inmate?.SortField?.split(" ")[0]}
                sortDirection={inmate?.SortField?.split(" ")[1]}
              />
            </div>
          </div>
        </div>
      ) : (
        <h4 className="facility-card">Select a Facility Code from the list</h4>
      )}
    </div>
  );
}

export default React.memo(InmateList);
